<template>
    <b-container fluid="md">
        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body class="px-0">
                <div v-if="statusCode" class="alert alert-danger">
                    {{statusCode}}: {{notFoundError}}
                </div>
                <div v-else>
                    <div v-if="!loadingImage">
                        <PreLoader/>
                    </div>
                    <b-row>
                        <b-col class="col-lg-8 nopadding">
                            <b-card-text v-if="loadingImage" class="border">
                                <pinch-zoom class="whitebackground"><img :src="'data:image/jpeg;base64,'+ image" class="w-100 h-100 invoice-image" /></pinch-zoom>
                            </b-card-text>
                        </b-col>
                    </b-row>
                </div>
            </b-card-body>
        </b-collapse>
    </b-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import PreLoader from '@/components/root/Preloader';
    import PinchZoom from 'vue-pinch-zoom';
    import $ from "jquery";

    export default {
        name: "DocumentImage",
        components: {PreLoader, PinchZoom},
        data: () => ({
            standardOpen: [0],
            hover: true,
            focusable: true,
            image: '',
            loadingImage: false,
            windowSize: $(window).width()
        }),
        props: {
          invoicePicture: null
        },
        computed: {
            ...mapGetters('fmwebapp',['invoice']),
            ...mapGetters('errors', ['statusCode', 'notFoundError'])
        },
        methods: {
            ...mapActions('fmwebapp', ['getImage', 'errors']),
            loadImage()
            {
                this.changeInvoiceImage(this.invoicePicture)
            },
            changeInvoiceImage(invoicePicture)
            {
                this.loadingImage = false

                var vm = this;
                vm.$store.dispatch('errors/clearErrors');

                vm.getImage(
                {
                    resource:"images",
                    filename: invoicePicture
                }
                ).then((response) => {
                    this.loadingImage = true
                    this.image = response;
                })
            },
            onResize() {
                this.windowSize = $(window).width();
            } 
        },
        created() {
            window.addEventListener('resize', this.onResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.onResize)
        },
        mounted(){
            this.loadImage();
        }
    }
</script>
<style>
    .expansionPanel{
        border-radius: 0 !important;
    }

    .nopadding {
        padding: 0;
    }

    .whitebackground {
        background-color: transparent !important;
    }

</style>